export default "__VITE_ASSET__81660484__"